export default "__VITE_ASSET__Cts8Q2Fe__"